import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		purchases: [],
	},

	actions: {
		fetchAll({ commit }, { providerId, ownerId, date, status, nonDeleted, orderByName, page, perPage }) {
			return axios.get('/purchases', { params: { providerId, ownerId, date, status, sortByCreatedAt: true, nonDeleted: true, orderByName, page, perPage } });
		},
		
		fetchById({ commit }, { id }) {
			return axios.get(`/purchases/${id}`);
		},

		create({ commit }, { date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns }) {
			return axios.post('/purchases', { date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns });
		},

		update({ commit }, { id, date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns }) {
			return axios.put(`/purchases/${id}`, { date, providerId, ownerId, entryNo, weight, density, isSeed, items, administrationPrice, administrationAcceptance, farmerAcceptance, pepperColumns });
		},

		updateState({ commit }, { id, administrationPrice, administrationAcceptance, farmerAcceptance }) {
			return axios.put(`/purchases/${id}/status`, { administrationPrice, administrationAcceptance, farmerAcceptance })
		},
		
		delete({ commit }, { id }) {
			return axios.delete(`/purchases/${id}`)
		},

		getWeightedAveragesByProvider ({ commit }, { providerId }) {
			return axios.get(`/Purchases/WeightedAveragesByProvider/${providerId}`).then(data => {
				return data
			})
		}
	},
}